import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const SUBSYSTEM_COLORS = {
  "Signalling": "#1e40af",
  "Rolling Stock": "#22c55e",
  "Power Supply": "#f59e0b",
  "PSD": "#3b82f6",
  "External": "#ef4444",
  "Others": "#94a3b8",
};
const FALLBACK = ["#1e40af", "#22c55e", "#f59e0b", "#3b82f6", "#ef4444", "#94a3b8", "#a855f7", "#14b8a6"];

export default function SubsystemDonut({ items = [] }) {
  const total = items.reduce((s, i) => s + (i.count || 0), 0) || 1;
  const withPct = items.map((i, idx) => ({
    ...i,
    color: SUBSYSTEM_COLORS[i.subsystem] || FALLBACK[idx % FALLBACK.length],
    pct: ((i.count || 0) / total) * 100,
  }));

  return (
    <div className="flex items-center gap-4 w-full h-full" data-testid="subsystem-donut">
      <div className="relative w-[160px] h-[160px] flex-shrink-0">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={withPct}
              dataKey="count"
              nameKey="subsystem"
              cx="50%"
              cy="50%"
              innerRadius={50}
              outerRadius={78}
              paddingAngle={2}
              stroke="none"
              isAnimationActive={false}
            >
              {withPct.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip formatter={(v, n) => [`${v} gangguan (${((v / total) * 100).toFixed(1)}%)`, n]} contentStyle={{ fontSize: 12, borderRadius: 8 }} />
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center pointer-events-none">
          <div className="text-xl font-black text-slate-900">{total.toLocaleString()}</div>
          <div className="text-[9px] uppercase tracking-widest text-slate-500 mt-0.5">Total<br/>Gangguan</div>
        </div>
      </div>

      <div className="flex-1 space-y-1.5 text-xs min-w-0">
        {withPct.map((i) => (
          <div key={i.subsystem || i.color} className="flex items-center gap-2 min-w-0">
            <div className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ background: i.color }} />
            <div className="text-slate-700 font-semibold truncate flex-1" title={i.subsystem}>{i.subsystem}</div>
            <div className="text-slate-500 tabular-nums whitespace-nowrap">
              {i.pct.toFixed(1)}% ({i.count})
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
